import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from './firebase'

export type WalletReservation = { reservationId: string; creditsReserved: number; status: string }
export type WalletReservationPurpose =
  | 'AI_CHAT'
  | 'SIMPLE_EDIT'
  | 'GENERATION'
  | 'ADVANCED_GENERATION'
  | 'TOUR_CONCIERGE_EXECUTE'
  | 'TOUR_GENERATION'
  | 'HELPER_CHAT_SUMMARY'
  | 'HELPER_CHAT_TRANSLATE'
  | 'AI_ANALYSIS_SUMMARY'
  | 'AI_CHART_DRAFT'
  | 'AI_CHART_EXPLAIN'
  | 'AI_CHART_SUGGEST'
const reservationId = () => globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`

export const walletService = {
  reserveCredits: async (workspaceId: string, amount: number, options: { reservationId?: string; purpose: WalletReservationPurpose; targetId?: string }) => {
    const call = httpsCallable<Record<string, unknown>, WalletReservation>(firebaseFunctions, 'atomicReserve')
    return (await call({ workspaceId, creditAmount: amount, reservationId: options.reservationId ?? reservationId(), purpose: options.purpose, targetId: options.targetId })).data
  },
  commitCredits: async (workspaceId: string, reservationId: string, amount?: number) => {
    const call = httpsCallable<Record<string, unknown>, { reservationId: string; status: string; creditsCharged: number; creditsReleased: number }>(firebaseFunctions, 'atomicCommit')
    return (await call({ workspaceId, reservationId, actualCredits: amount })).data
  },
  releaseCredits: async (workspaceId: string, reservationId: string) => {
    const call = httpsCallable<Record<string, unknown>, { reservationId: string; status: string; creditsCharged: number; creditsReleased: number }>(firebaseFunctions, 'atomicRelease')
    return (await call({ workspaceId, reservationId })).data
  },
}
